import { notify } from '@billy/design-system'

import { NotificationKeys } from '../../../enums/notificationKeys'

interface NotifyItemUnavailableOptions {
  message: string
}

export const notifyItemUnavailable = ({ message }: NotifyItemUnavailableOptions) => {
  notify({
    id: NotificationKeys.DocumentsItemUnavailable,
    message,
    variant: 'error',
    icon: 'circleX',
  })
}
